import OpenApiTokens from '../api_tokens/open_api_tokens';
import OpenLookupApi from './open_lookup_api';

export default class OpenIntegrations {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (
      !this.context.stores.appFeatures.get().isEnabled('integrationsManagement') &&
      !this.context.stores.appFeatures.get().isEnabled('devManagement')
    ) {
      this.context.router.navigateHome();
      return;
    }

    if (this.context.stores.appFeatures.get().isEnabled('devManagement')) {
      this.context.executeAction(OpenApiTokens);
    } else {
      this.context.executeAction(OpenLookupApi);
    }

    if (
      this.context.stores.appFeatures.get().isEnabled('integrationsManagement') &&
      !this.context.stores.lookupApiConfig.get()
    ) {
      this.context.gateways.customerLookupConfiguration.request();
      this.context.stores.lookupApiConfig.setLoading();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/open_integrations.js